import { render, staticRenderFns } from "./TiptapToolbar.vue?vue&type=template&id=239a4a7f"
import script from "./TiptapToolbar.vue?vue&type=script&setup=true&lang=js"
export * from "./TiptapToolbar.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports